import { useSelector } from 'react-redux';

import { formatDateCustom } from 'modules/I18N';
import { TimelineItem } from 'lib/Timeline';
import { DetailedInventoryAsset } from 'components/common/types/DetailedInventoryAsset.types';
import { Store } from 'components/common/types/Store.types';

type Prohibition = DetailedInventoryAsset['prohibitions'][number];

type ProhibitionInfoProps = {
  prohibitionGroup: Prohibition[];
};

const ProhibitionInfo = ({ prohibitionGroup }: ProhibitionInfoProps): React.ReactElement => {
  const { localeCode } = useSelector((state: Store) => state.publisher.configuration);
  const dateFormatOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    timeZone: 'UTC',
  };

  return (
    <TimelineItem
      title={
        <div className="grid grid-cols-3 gap-x-4 items-center" data-test-id="prohibition-group">
          {prohibitionGroup.map(({ productCategoryUuid, productCategoryName }) => (
            <p key={productCategoryUuid} className="body-sm break-all">
              {productCategoryName}
            </p>
          ))}
        </div>
      }
    >
      <div className="grid grid-cols-3 gap-x-4">
        {prohibitionGroup.map(({ productCategoryUuid, startDate, endDate }) => (
          <p
            key={productCategoryUuid}
            className="body-sm text-neutral-950-opacity-60"
          >{`${formatDateCustom(startDate, dateFormatOptions, localeCode)}-${formatDateCustom(endDate, dateFormatOptions, localeCode)}`}</p>
        ))}
      </div>
    </TimelineItem>
  );
};

export default ProhibitionInfo;
